import { createSelector } from 'reselect';
import { settings } from '../settings';

export const CHANGE_LIST_VIEW = 'items/CHANGE_LIST_VIEW';

export const FETCH_ITEM = 'items/FETCH_ITEM';

export const FETCH_LIST = 'items/FETCH_LIST';

export const FETCH_MORE = 'items/FETCH_MORE';

export const changeListViewAction = payload => ({ type: CHANGE_LIST_VIEW, payload });
export const fetchListAction = payload => ({ type: FETCH_LIST, payload });
export const fetchMoreAction = payload => ({ type: FETCH_MORE, payload });
export const fetchItemAction = payload => ({ type: FETCH_ITEM, payload });

export const itemsInitialState = {
  item: {},
  lists: {},
  view: 'list',
};

export const itemsReducer = (state = itemsInitialState, action) => {
  switch (action.type) {
  case CHANGE_LIST_VIEW:
    return {
      ...state,
      view: action.payload,
    };
  case FETCH_ITEM:
    return {
      ...state,
      item: { ...action.payload },
    };
  case FETCH_LIST:
    return {
      ...state,
      lists: {
        ...state.lists,
        [action.payload.type]: { ...action.payload },
      },
    };
  case FETCH_MORE: {
    const { type, page, status, noMoreItems, items = [] } = action.payload;
    const currentList = state.lists[type];
    const { pageStops } = currentList;
    const { length } = items;
    return {
      ...state,
      lists: {
        ...state.lists,
        [type]: {
          ...currentList,
          page,
          status,
          noMoreItems,
          pageStops: length ? [...pageStops, pageStops[pageStops.length - 1] + length] : pageStops,
          list: [...currentList.list, ...items],
        },
      },
    };
  }
  default:
    return state || itemsInitialState;
  }
};

export const toPositiveInt = n => Number.isInteger(n) ? Math.max(n, 0) : 0;

export const selectItem = state => state.items.item;

export const selectItemStatus = createSelector(selectItem, ({ status }) => status);

export const selectItemIsLoaded = createSelector(selectItemStatus, status => status === 'loaded');
export const selectItemIsLoading = createSelector(selectItemStatus, status => status === 'loading');

export const selectItemDetails = createSelector(selectItem, ({ item }) => item || { nopreroll: true, tags: '' });

export const selectItemId = createSelector(selectItemDetails, ({ id }) => id);
export const selectItemNSFW = createSelector(selectItemDetails, ({ nsfw }) => nsfw);
export const selectItemNopreroll = createSelector(selectItemDetails, ({ nopreroll }) => nopreroll);
export const selectItemTags = createSelector(selectItemDetails, ({ tags }) => tags);
export const selectItemMedia = createSelector(selectItemDetails, ({ media }) => media);
export const selectItemUploadId = createSelector(selectItemDetails, ({ upload_id }) => upload_id);

export const selectItemsView = state => state.items.view;

export const selectIsCardsView = createSelector(selectItemsView, view => view === 'cards');

export const selectList = (state, typeOfList) => {
  if (!typeOfList) {
    return {};
  }
  const list = state.items.lists[typeOfList];
  return list ? list : {};
};

export const selectItemsList = createSelector(
  selectList,
  list => list.list ? list.list : [],
);

export const selectItemsListParams = createSelector(selectList, ({ params }) => params || {});

export const selectItemsListPageStops = createSelector(selectList, ({ pageStops }) => pageStops || []);

export const selectItemsListMediaFilter = createSelector(selectList, ({ filter }) => filter);

export const selectNsfwFilter = createSelector(selectList, ({ active }) => active);

export const selectItemsListStatus = createSelector(selectList, ({ status }) => status);

export const selectItemsListError = createSelector(selectList, ({ error }) => error);

export const selectNoMoreItems = createSelector(selectList, ({ noMoreItems }) => noMoreItems);

export const selectItemsListPage = createSelector(
  selectList,
  ({ page }) => toPositiveInt(page),
);

export const selectItemsListLoadedAt = createSelector(
  selectList,
  ({ loadedAt }) => toPositiveInt(loadedAt),
);

export const selectItemsListIsLoaded = createSelector(
  selectItemsListStatus,
  selectItemsListError,
  (status, error) => status === 'loaded' && !error,
);

export const selectItemsListIsLoading = createSelector(
  selectItemsListStatus,
  status => status === 'loading',
);

export const selectItemsListIsLoadingMore = createSelector(
  selectItemsListStatus,
  status => status === 'loadingMore',
);

export const selectItemsListNeedsToBeLoaded = createSelector(
  selectItemsListIsLoading,
  selectItemsListIsLoaded,
  selectItemsListLoadedAt,
  (isLoading, isLoaded, loadedAt) => !isLoading && (
    !isLoaded
    || Date.now() - loadedAt > settings.MAX_AGE)
    || (new Date(loadedAt)).getDate() !== (new Date()).getDate(),
);

export const selectItemsListState = createSelector(
  selectItemsListIsLoading,
  selectItemsListIsLoaded,
  selectItemsListError,
  selectItemsList,
  (isLoading, isLoaded, error, items) => ({ isLoading, isLoaded, error, items }),
);
